import { Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {SettingsService} from "./services/settings-service";
import { environment } from "../../../environments/environment";

@Component({
  selector: 'openpay-configuration-page',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss']
})

export class ConfigurationPageComponent implements OnInit {
  attrCheckboxName: string = 'disabled'
  installmentsIsChange = false;
  payments = [];
  countryCode: string = '';
  isTipEnabled: boolean = false;
  storeId = 0;
  loader = false;
  initialLoader = false;
  successToast = false;
  attemptErrorSection = false;
  errorSection = false;
  cancelUrl = "";
  modal = false;
  modalExitPage = '';

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private settingsService: SettingsService
  ) {
  }

  ngOnInit() {
    //const storeId = this.activatedRoute.snapshot.params['storeId'];
    const storeId = this.activatedRoute.snapshot.queryParamMap.get("idMerchantReferenced")
    this.countryCode = this.activatedRoute.snapshot.queryParamMap.get("country")
    console.log(this.countryCode);
    if(!storeId){
      this.router.navigate(['not-found']).then()
      return
    }
    this.getInstallments(storeId)
  }

  toggleTip(event: any) {
    this.isTipEnabled = event.target.checked;
    this.installmentsIsChange = true;
  }

  getInstallments(storeId){
    this.loader = true;
    this.initialLoader = true;
    this.settingsService.getInstallments(storeId).subscribe((data) => {
      console.log(data.settings);
      if(data.status){
        setTimeout(() => {
          this.loader = false;
          this.initialLoader = false;
        }, 3000);
        this.storeId = storeId;
        this.cancelUrl = data.cancel_url;
        if(data.settings.tip != null ) {
          this.isTipEnabled = data.settings.tip;
        }
        if(data.settings.payment_plan.payments != null ) {
          this.payments = data.settings.payment_plan.payments.split(',').map((e) => e.trim());
        } else {
          this.payments = [];
        }
      } else {
        setTimeout(() => {
          this.router.navigate(['not-found']).then()
          return
        }, 3000);
      }
    }, error => {
      setTimeout(() => {
        this.router.navigate(['not-found']).then()
        return
      }, 3000);
    });
  }

  checkboxChange(event){
    const installment = event.target.value;
    if(event.target.checked){
      if(!this.payments.includes(installment)) this.payments.push(installment)
    } else {
      if(this.payments.includes(installment)) {
        const payments = this.payments.filter(element => element !== installment);
        this.payments = payments;
      }
    }
    console.log(this.payments);
    this.installmentsIsChange = true;
  }

  saveInstallments(){
    this.modal = false;
    this.attemptErrorSection = false;
    this.errorSection = false;
    const body = {
      storeId: this.storeId,
      settings: {
        tip: this.countryCode === 'CO' ? this.isTipEnabled : false,
        payment_plan:{
          payments: this.payments.length > 0 ? this.payments.toString() : null,
          payments_type: 'WITHOUT_INTEREST'
        }
      }
    }
    this.loader = true;
    this.settingsService.updateMerchantsParams(body).subscribe((data) => {
      if(data.status) {
        setTimeout(() => {
          this.loader = false;
          this.installmentsIsChange = false;
          sessionStorage.removeItem('attempts');
          this.showSucchessToast();
        }, 3000);
      } else {
        setTimeout(() => {
          this.loader = false;
          this.attemptErrorSection = true;
          if(sessionStorage.getItem('attempts')){
            let attempts = parseInt(sessionStorage.getItem('attempts'));
            attempts = attempts + 1;
            sessionStorage.setItem('attempts', attempts.toString());
            if(attempts > 2){
              this.attemptErrorSection = false;
              this.errorSection = true;
            }
          } else {
            sessionStorage.setItem('attempts', '1')
          }
        }, 3000);
      }
    }, (error) => {
      setTimeout(() => {
        this.loader = false;
        this.attemptErrorSection = false;
        this.errorSection = true;
      }, 3000);
    })
  }

  showSucchessToast(){
    this.successToast = true;
    setTimeout(() => {
      this.successToast = false;
    }, 6000);
  }

  backToNuvemshop(){
    sessionStorage.removeItem('attempts');
    window.location.href = this.cancelUrl
  }

  backTo(page:string){
    if(this.installmentsIsChange){
      this.modal = true;
      this.modalExitPage = page;
    } else {
      if(page == 'nuvemshop') this.backToNuvemshop();
      if(page == 'fees') this.goToComisionesInfo();
    }
  }

  goToComisionesInfo(){
    window.location.href = environment.openpayComisionesMx
  }

  exit(){
    if(this.modalExitPage == 'nuvemshop') this.backToNuvemshop();
    if(this.modalExitPage == 'fees') this.goToComisionesInfo();
  }

}
